import { useSelector } from "react-redux";
import { Row, Col, Nav } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import ProfileUnselect from '../../../../styles/images/profile-unselect-50.png';
import ProfileSelect from '../../../../styles/images/profile-selected-50.png';
import WalletUnselect from '../../../../styles/images/wallet-unselect-50.png';
import WalletSelect from '../../../../styles/images/wallet-selected-50.png';
import HomeIcon from '../../../../styles/images/home.png';


const FooterWithHomeBtn = (props) => {

    const navigate = useNavigate();

    const { isOpen } = useSelector(state => state.bottom_sheet);


    return (

        <Nav id="nav-bottom" className="navbar fixed-bottom text-center bg-white px-4" style={ !isOpen ? {boxShadow: '0px -5px 10px rgba(0, 0, 0, 0.2)'} : null }>

            


            <Row className="w-100 py-1 mx-0">
                <Col xs={4} className="text-center align-items-center">
                    <Link to="../wallet" className={"bottom-nav " + (props.selected !== undefined && props.selected === 'wallet' ? "bottom-nav-select" : "bottom-nav-unselect")} >
                        <img src={props.selected !== undefined && props.selected === 'wallet' ? WalletSelect : WalletUnselect} height={30} alt="کیف پول" />
                        <br />
                        کیف پول
                    </Link>
                </Col>
                <Col xs={4} className="d-flex justify-content-center p-0" >
                    <div className="footer-home-btn d-flex flex-column justify-content-center align-items-center" onClick={() => navigate('../')} role="button" >
                        <img src={HomeIcon} alt="صفحه اصلی" width={50} />
                    </div>
                    
                </Col>
                <Col xs={4} className="text-center align-items-center">
                    <Link to="../profile" className={"bottom-nav " + (props.selected !== undefined && props.selected === 'profile' ? "bottom-nav-select" : "bottom-nav-unselect")} >
                        <img src={props.selected !== undefined && props.selected === 'profile' ? ProfileSelect : ProfileUnselect} height={30} alt="پروفایل" />
                        <br />
                        پروفایل
                    </Link>
                </Col>
            </Row>

            

        </Nav>

    );
}

export default FooterWithHomeBtn;
